import React, { Component } from 'react';

import './App.css';

import anprosem from './assets/anprosem.png';

class Footer extends Component {
  render() {
    return (
        <footer>
            Associada:<br/>
            <a href="http://www.anprosem.com.br/"><img src={anprosem} id="foot-logo"/></a>
        </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Footer.js